// extracted by mini-css-extract-plugin
export default {"checkouts_container":"checkouts_checkouts_container__uMeXN","title":"checkouts_title__NufC6","table_container":"checkouts_table_container__8cYTZ"};